import { takeEvery, call, put, select } from 'redux-saga/effects'

import { ADD_TO_BAG, ADD_ROOM_TO_BAG, OPEN_BAG } from 'models/actionTypes'

import { getShoppingCartUrl, getAddToCartUrl } from 'utils/buildUrls'
import * as cartApi from 'services/spiderpigs'
import { getRegion, getLanguageCodeFromRegion } from 'models/location/selectors'

import { ADDED_TO_BAG_TOAST } from 'toasts/toastTypes'
import { showToast } from 'models/toasts/actions'

export function* addToBag(action) {
    const hasToken = yield call(cartApi.hasToken)

    try {
        if (hasToken) {
            const region = yield select(getRegion)
            const lang = yield select(getLanguageCodeFromRegion, region)
            yield call(cartApi.addToCart, lang, [[action.localItemNumber, 1]])
            yield put(showToast(ADDED_TO_BAG_TOAST, { name: action.name }))
        } else {
            const cartUrl = getAddToCartUrl([action.localItemNumber], action.region)
            window.open(cartUrl, '_blank')
        }
    } catch (error) {
        yield put(showToast(ADDED_TO_BAG_TOAST, { name: action.name, failed: true }))
    }
}

export function* addRoomToBag(action) {
    const hasToken = yield call(cartApi.hasToken)

    try {
        if (hasToken) {
            const region = yield select(getRegion)
            const lang = yield select(getLanguageCodeFromRegion, region)
            const items = action.localItemNumbers.reduce((acc, num) => {
                if (acc[num]) {
                    acc[num] += 1
                } else {
                    acc[num] = 1
                }
                return acc
            }, {})
            yield call(cartApi.addToCart, lang, Object.entries(items))
            yield put(showToast(ADDED_TO_BAG_TOAST, { count: action.localItemNumbers.length }))
            // In the case of the Design summary modal for the mobile web, we do not want to redirect
            // to the cart url. Instead we want to show and exit popup that has a checkout button.
            // In this case, we pass the blockRedirect parameter as true. It is false by default.
        } else if (!action.blockRedirect) {
            const cartUrl = getAddToCartUrl(action.localItemNumbers, action.region)
            window.open(cartUrl, '_blank')
        }
    } catch (error) {
        yield put(showToast(ADDED_TO_BAG_TOAST, { count: action.localItemNumbers.length, failed: true }))
    }
}

export function* openBag() {
    const region = yield select(getRegion)
    const shoppingCartUrl = getShoppingCartUrl(region)
    window.open(shoppingCartUrl, '_blank')
}

function* watchAddToBag() {
    yield takeEvery(ADD_TO_BAG, addToBag)
}

function* watchAddRoomToBag() {
    yield takeEvery(ADD_ROOM_TO_BAG, addRoomToBag)
}

function* watchOpenBag() {
    yield takeEvery(OPEN_BAG, openBag)
}

export const bagSagas = [watchAddToBag(), watchAddRoomToBag(), watchOpenBag()]
